import {TextField, TextArea, Field, type SectionProps} from '../controls';

export function CheckoutSection({config, patch}: SectionProps) {
  const checkout = config.checkout ?? {};

  function patchCheckout(next: Partial<NonNullable<typeof config.checkout>>) {
    patch({checkout: {...checkout, ...next}});
  }

  return (
    <div className='space-y-5'>
      <Field label='Date of hire' hint='Collect a date-of-hire field on the checkout form.'>
        <label className='flex items-center gap-2 text-sm'>
          <input
            type='checkbox'
            checked={!!checkout.collectDateOfHire}
            onChange={(e) => patchCheckout({collectDateOfHire: e.target.checked || undefined})}
          />
          Collect date of hire
        </label>
      </Field>
      <TextField
        label='Phone field label'
        hint='Falls back to "Phone".'
        value={checkout.phoneLabel}
        onChange={(phoneLabel) => patchCheckout({phoneLabel: phoneLabel || undefined})}
      />
      <TextArea
        label='SMS consent disclosure'
        hint='If set, renders an SMS-consent checkbox with this text.'
        value={checkout.smsConsentDisclosure}
        onChange={(smsConsentDisclosure) => patchCheckout({smsConsentDisclosure: smsConsentDisclosure || undefined})}
      />
    </div>
  );
}
